"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
const vue_1 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const vue_router_1 = require("vue-router");
const vuex_1 = require("vuex");
const element_plus_1 = require("element-plus");
const seo_1 = require("@/hooks/seo");
const uniframe_1 = require("@/hooks/uniframe");
const Default_1 = __importDefault(require("@/layout/Default"));
const Exchange_1 = __importDefault(require("@/layout/Exchange"));
const Mobile_1 = __importDefault(require("@/layout/Mobile"));
const element_locales_1 = require("@/locales/element-locales");
const monitor_1 = require("@/utils/monitor");
const sensors_1 = require("@/utils/sensors");
exports.default = {
  setup() {
    const {
      locale,
      messages
    } = (0, vue_i18n_1.useI18n)({
      useScope: 'global'
    });
    const elLocale = (0, vue_1.computed)(() => (0, element_locales_1.getElementLocale)(locale.value || 'en'));
    const route = (0, vue_router_1.useRoute)();
    const store = (0, vuex_1.useStore)();
    const layout = (0, vue_1.computed)(() => route.meta.layout || '');
    const uniFrame = (0, uniframe_1.useUniFrame)();
    const {
      isMobile = false
    } = window.sfe;
    const timer = null;
    (0, seo_1.useSEO)();
    if (!window.sfe.prerender) {
      store.dispatch('user/INIT');
      uniFrame.init();
    }
    // 绑定更新
    (0, vue_1.watch)(() => locale.value, () => {
      store.dispatch('settings/INIT_LEGAL');
    });
    (0, vue_1.watch)(() => route.meta.layout, () => {
      document.documentElement.setAttribute('data-layout', route.meta.layout);
      document.body.setAttribute('data-layout', route.meta.layout);
    });
    (0, vue_1.watch)(() => route.meta.fixed_header, () => {
      document.documentElement.setAttribute('fixed-header', route.meta.fixed_header);
    });
    // 监听是否需要获取kyc信息
    (0, vue_1.watch)(() => store.getters['user/isLogin'] && route.meta.needKyc, val => {
      if (val) store.dispatch('user/GET_KYC_INFO');
    }, {
      immediate: true
    });
    const methods = {
      // 监听页面隐藏显示设置状态
      visibilityChange() {
        store.commit('settings/SET_PAGE_STATUS', {
          type: 'show',
          status: document.hidden,
          ts: Date.now()
        });
      },
      online(ev) {
        store.commit('settings/SET_PAGE_STATUS', {
          type: 'online',
          status: ev.type === 'online',
          ts: Date.now()
        });
      },
      // 路径矫正
      redirectPath() {
        const routeMap = {
          PC_REG: /\/trade\/spot\/loan$/ig,
          PC: '/loan',
          H5_REG: /\/trade\/spot\/loan-m/ig,
          H5: '/loan-m'
        };
        const url = window.location.href;
        let reg;
        let replaceTarget = [];
        if (isMobile) {
          reg = routeMap.PC_REG;
          replaceTarget = [routeMap.PC, routeMap.H5];
        } else {
          reg = routeMap.H5_REG;
          replaceTarget = [routeMap.H5, routeMap.PC];
        }
        if (reg.test(url)) {
          const newUrl = url.replace(replaceTarget[0], replaceTarget[1]);
          window.location.replace(newUrl);
        }
      }
    };
    (0, vue_1.onMounted)(() => {
      document.addEventListener('visibilitychange', methods.visibilityChange, false);
      window.addEventListener('online', methods.online, false);
      window.addEventListener('offline', methods.online, false);
      // H5,PC路径纠正
      methods.redirectPath();
    });
    (0, vue_1.onBeforeUnmount)(() => {
      document.removeEventListener('visibilitychange', methods.visibilityChange, false);
      window.removeEventListener('online', methods.online, false);
      window.removeEventListener('offline', methods.online, false);
    });
    // 非预渲染时初始化天网，不能在 `onload` 事件，因为有其他数据要向天网里推送
    if (!window.sfe.prerender) {
      (0, monitor_1.init)();
      (0, sensors_1.init)();
    }
    // 删除整体 Loading 占位
    try {
      const el = document.querySelector('.root-placeholder-loading');
      el.style.opacity = '0';
      el.style.zIndex = '-999';
      el.style.overflow = 'hidden';
      // if (el) el.parentElement.removeChild(el);
    } catch (e) {} // eslint-disable-line
    return {
      elLocale,
      layout
    };
  },
  components: {
    Default: Default_1.default,
    Exchange: Exchange_1.default,
    Mobile: Mobile_1.default,
    ElConfigProvider: element_plus_1.ElConfigProvider
  }
};